import {
  NorthbeamUtms,
  UtmGuideHeader,
  LegacyUtms,
} from "@features/utm-guide/components";

export const UtmGuide = () => (
  <div className="bg-white px-7 p-5 rounded-md flex flex-col gap-3 border container-xl">
    <div className="flex flex-col gap-3">
      <h1 className="heading mx-0 mb-0 mt-0">UTM Guide</h1>
      <hr className="mb-0 mt-0" />
    </div>
    <div className="flex flex-col grow relative gap-4">
      <UtmGuideHeader />
      <NorthbeamUtms />
      <LegacyUtms />
    </div>
  </div>
);
